import { Pipe, PipeTransform } from '@angular/core';

const PROPERTY_NAME = 0;
const JOIN_SIGN = 1;

@Pipe({
  name: 'join',
  standalone: true,
})
export class JoinPipe implements PipeTransform {
  transform(value: string[], ...args: any[]): unknown {
    return value.map((val: string) => val[args[PROPERTY_NAME]]).join(args[JOIN_SIGN]);
  }
}
